import { Box, Chip } from "@mui/material";
import { DataGrid, GridColDef, GridRenderCellParams, GridToolbar } from "@mui/x-data-grid";
import React from "react";

interface Payment {
  chargeId: string;
  amount: number;
  amountRefunded: number;
  currency: string;
  refunded: boolean;
  paymentMethod: string;
  country: string;
  brand: string;
  last4: string;
  email: string;
  phoneNumber?: number;
  name?: string;
  receipt?: string;
}

interface TableProps {
  data: Payment[];
  loading: boolean;
}

const PaymentTable: React.FC<TableProps> = ({ data, loading = false }) => {

    const rows = data.map((payment: Payment, index: any) => ({
        id: payment.chargeId,
        name: payment.name,
        userEmail: payment.email,
        amount: payment.amount,
        amountRefunded: payment.amountRefunded,
        refunded: payment.refunded,
        paymentMethod: payment.paymentMethod,
        brand: payment.brand,
        country: payment.country,
        lastFourDigits: payment.last4,
    }))

    const columns: GridColDef[] = [
        // { field: "id", headerName: "Charge ID", width: 150 },
        { field: "name", headerName: "Name", width: 150 },
        { field: "userEmail", headerName: "Email", width: 150 },
        { field: "amount", headerName: "Amount", width: 150 },
        { field: "amountRefunded", headerName: "Amount Refunded", width: 150 },
        {
            field: "refunded",
            headerName: "Payment Status",
            width: 150,
            renderCell: (params: GridRenderCellParams<Payment>) => (
                <Chip label={params.row.refunded? 'Refunded' : 'Succeeded'} />
            )
        },
        { field: "paymentMethod", headerName: "Payment Method", width: 150 },
        { field: "brand", headerName: "Brand", width: 150 },
        { field: "country", headerName: "Country", width: 150 },
        { field: "lastFourDigits", headerName: "Last Four Digits", width: 150 },
    ]
  return (
    <Box style={{ height: 550, width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row.id}
        loading={loading}
        density="standard"
        disableRowSelectionOnClick
        disableColumnFilter
        slots={{ toolbar: GridToolbar }}
        slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
        disableDensitySelector
      />

    </Box>
  );
};

export default PaymentTable;